// extracted by mini-css-extract-plugin
export default {"pageButton":"Pagination_pageButton__k-5Gy","pageButtonActive":"Pagination_pageButtonActive__T7oDw"};